function initMegaMenuPromos() {
  // Desktop: each .mega-menu-3l wrapper has one promo placeholder (outside panels loop),
  // matched by data-l1-title on the wrapper element.
  document.querySelectorAll('.mega-menu-3l[data-l1-title]').forEach(wrapper => {
    if (!(wrapper instanceof HTMLElement)) return;
    const title = (wrapper.dataset.l1Title || '').trim().toLowerCase();
    const promoEl = document.querySelector(`.promo-panel-data[data-menu-item="${title}"]`);
    if (!promoEl) return;

    const promoInner = promoEl.querySelector('.mega-menu-3l__promo');
    if (!promoInner) return;

    const placeholder = wrapper.querySelector('.mega-menu-3l__promo--placeholder');
    if (!(placeholder instanceof HTMLElement)) return;
    // Guard on children presence, not the CSS class — a Shopify node-update
    // wipe clears children but can leave the class behind, so class-only checks
    // would incorrectly skip re-injection after a wipe.
    if (placeholder.children.length > 0) return;
    const clone = promoInner.cloneNode(true);
    placeholder.appendChild(clone);
    placeholder.style.removeProperty('display');
    placeholder.classList.add('mega-menu-3l__promo--active');
  });

  // Mobile: standalone placeholders carry their own data-l1-title
  document.querySelectorAll('.mega-menu-3l__promo--mobile.mega-menu-3l__promo--placeholder[data-l1-title]').forEach(placeholder => {
    if (!(placeholder instanceof HTMLElement)) return;
    if (placeholder.children.length > 0) return;
    const title = (placeholder.dataset.l1Title || '').trim().toLowerCase();
    const promoEl = document.querySelector(`.promo-panel-data[data-menu-item="${title}"]`);
    if (!promoEl) return;

    const promoInner = promoEl.querySelector('.mega-menu-3l__promo');
    if (!promoInner) return;

    const clone = promoInner.cloneNode(true);
    placeholder.appendChild(clone);
    placeholder.style.removeProperty('display');
    placeholder.classList.add('mega-menu-3l__promo--active');
  });
}

// Run immediately for server-rendered content
initMegaMenuPromos();

// Re-inject promos whenever the header-menu or mega-menu structure changes.
//
// Why this observer exists:
//   Shopify's theme node-update system can wipe our injected content when it
//   re-renders or patches the menu DOM.  The previous approach used a broad
//   document.body observer with a 200ms debounce; the debounce was the source
//   of the flickering (users could hover an L2 item before the promo was
//   re-injected).  Removing the debounce and reacting immediately prevents
//   that window.
//
// Why we check both target.closest and addedNodes:
//   • target.closest('header-menu') catches any childList change *inside* an
//     already-present header-menu element, including Shopify wiping placeholder
//     children mid-session.
//   • The addedNodes walk catches the case where header-menu (or a mega-menu-3l
//     wrapper) is inserted into the DOM for the first time during deferred
//     hydration, when the mutation target is the *parent*, not the element itself.
//
// Why children.length instead of the CSS class:
//   A Shopify wipe may clear children while leaving our added class in place.
//   Checking children.length is the authoritative "is this populated" test.
const observer = new MutationObserver(mutations => {
  let needsUpdate = false;

  outer: for (const mutation of mutations) {
    // Case 1: the mutated node is already inside the menu
    const target = mutation.target;
    if (target instanceof HTMLElement) {
      if (target.closest('header-menu') || target.closest('.mega-menu-3l')) {
        needsUpdate = true;
        break outer;
      }
    }

    // Case 2: header-menu / mega-menu elements added to the page for the
    // first time (deferred hydration — mutation target is the parent wrapper)
    for (const node of mutation.addedNodes) {
      if (!(node instanceof HTMLElement)) continue;
      if (
        node.matches('header-menu') ||
        node.matches('.mega-menu-3l') ||
        node.matches('.mega-menu-3l__promo--placeholder') ||
        node.querySelector('header-menu') ||
        node.querySelector('.mega-menu-3l') ||
        node.querySelector('.mega-menu-3l__promo--placeholder')
      ) {
        needsUpdate = true;
        break outer;
      }
    }
  }

  if (needsUpdate) initMegaMenuPromos();
});

// The menu, the mobile drawer and the promo-panel data all live in the header group,
// so observe only that subtree: page-level re-renders (Boost grids, cart morphs, app
// widgets) no longer trigger this callback.
observer.observe(document.getElementById('header-group') || document.body, { childList: true, subtree: true });

// Re-run when a Shopify section reloads in the theme editor
document.addEventListener('shopify:section:load', initMegaMenuPromos);
